import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import Loader from './../shared/loader'
import Multiselect from 'vue-multiselect'
import Pagination from './../shared/pagination'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs';

export default {
	name: 'rackZoneMaster',
	components: {
		Pagination,
		Loader,
		Multiselect
	},
	data: function() {
		return {
			file: '',
			warehouseid: '',
			createdbyuserid: '',
			zoneListData: [],
			addZonemodal: false,
			isLoading: false,
			is_Loading: false,
			listWarehouseData: [],
			warehouse: '',
			warehouseModal: '',
			zoneName: '',
			rackListData: [],
			username: '',
			zone: '',
			listZoneData: '',
			totalrows: 0,
			totalPage: 0,
			pageLimit: 10,
			currentPage: 1,
			rackName: '',
			modalShowDelete: false,
			warehouseError: '',
			delRackNo: '',
			delId: '',
			user_type: '',
			useremail: '',
			systemLoginCheck: false,
			warehouseLoginCheck: false,
		}
	},
	created: function() {},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.warehouseid = userdetail.warehouseid;
		this.createdbyuserid = userdetail.userid;
		this.username = userdetail.fullname;
		this.user_type = userdetail.utype;
		this.useremail = userdetail.email;

		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedWarehouse")!=='undefined')
		{
			this.getWarehouseList();
			this.getZoneList();
		}
		switch (this.user_type) {
			case 'system_user':
				// this.getWarehouseList();
				this.systemLoginCheck = true;
				this.warehouseLoginCheck = false;
				break;

			case 'client_user':
				this.systemLoginCheck = false;
				this.warehouseLoginCheck = false;
				break;

			case 'warehouse_user':
				this.systemLoginCheck = false;
				this.warehouseLoginCheck = true;
				this.warehouse = userdetail.warehouseid;
				this.warehouseModal = userdetail.warehouseid;
				this.getRackListByWarehouse();
				this.getRacksZonesList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break;
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getWarehouseList();
			this.getZoneList();
		  });

	},
	computed: {

	},
	methods: {
		resetAddForm() {
			// this.warehouse = ''
			//this.warehouseModal = ''
			document.getElementById('file').value = '';
			this.file = ''
			this.zoneName = ''
			this.$validator.reset();
		},
		closeDeleteModal() {
			this.modalShowDelete = false
		},
		async deleteMappingModal() {
			try {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.is_Loading = true
				let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'deleteRackMapping',
					'data': {
						rackno: this.delRackNo.trim(),
						id: this.delId
					},
					'headers': {
						'Authorization': 'Bearer ' + myStr
					}
				})
				if (result.data.errorCode == 0) {
					this.$alertify.success(result.data.msg)
					this.modalShowDelete = false
					this.getRacksZonesList()
				} else {
					this.$alertify.error("Mapped not Deleted")
				}
				this.is_Loading = false
			} catch (err) {
				console.log(err);
			}
		},
		deleteMapping(data) {
			this.delRackNo = data.rackno
			this.delId = data.id
			this.modalShowDelete = true
		},
		onPageChange(page) {
			this.currentPage = page;
			this.getRacksZonesList()
		},
		async getRacksZonesList() {
			try {
				if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;
				}
				this.isLoading = true
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getZonesRacks',
					'data': {
						warehouseid: localStorage.getItem("selectedWarehouse"),
						zoneid: this.zone,
						rackName: this.rackName.trim(),
						limit: this.pageLimit,
						offset: (this.currentPage - 1) * this.pageLimit
					},
					'headers': {
						'Authorization': 'Bearer ' + myStr
					}
				})
				this.zoneListData = result.data.data.rows;

				this.zoneListData.forEach((zld) => {
					this.listWarehouseData.forEach((lwd) => {
						if (zld.warehouseid == lwd.warehouseid) {
							zld.warehouseid = lwd.warehousename
						}
					})
					this.listZoneData.forEach((lzd) => {
						if (zld.zoneid == lzd.zoneid) {
							zld.zoneid = lzd.zonename
						}
					})
				})
				this.totalrows = result.data.data.count;
				if (this.totalrows < this.pageLimit) {
					this.totalPage = 1
				} else {
					this.totalPage = Math.ceil(this.totalrows / this.pageLimit);
				}
				this.isLoading = false
			} catch (err) {
				console.log(err);
			}
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		},
		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
			var csvData = ''
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ','
			}
			csvData = csvData.slice(0, csvData.length - 1)
			csvData += '\r\n'
			data.map(function(item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilder.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
							else
								csvData += escapedCSV + ','
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1)
				csvData += '\r\n'
			})
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n')
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		downloadRacks() {
			this.csvFields = {
				'id': this.$t('common.id'),
				'warehouseid': this.$t('common.warehouseID'),
				'racktype': this.$t('common.rackType'),
				'racksequence': this.$t('editedjson.rackSequence'),
				'rackno': this.$t('activities.racks'),
			};
			var dateFilder = [];
			var skipFilter = [];
			this.jsonToCSV(this.$t('editedjson.racksData'), this.rackListData, this.csvFields, dateFilder, skipFilter);
		},
		// warehouseSelected() {
		// 	if (this.warehouse) {
		// 		this.warehouseError = ''
		// 	}
		// 	this.getZoneList()
		// },
		async getZoneList() {
			try {
				console.log("kk");
				if (this.warehouse) {
					console.log("kkkkkkkllll");
					this.listZoneData = []
					this.isLoading = true
					var userToken = window.localStorage.getItem('userToken')
					var myStr = userToken.replace(/"/g, '')
					let result = await axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getZonesByWarehouse',
						'data': {
							warehouseid: localStorage.getItem("selectedWarehouse")
						},
						'headers': {
							'Authorization': 'Bearer ' + myStr
						}
					})
					this.listZoneData = result.data.data.data;
					this.isLoading = false
				}
			} catch (err) {
				console.log(err);
			}
		},
		warehouseSelectedModal() {
			this.getRackListByWarehouse()
		},
		async submitFile() {
			try {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				if (this.file == '' || this.$refs.file.files[0].type != 'text/csv') {
					this.$alertify.error("Please select csv file!");
					return false;
				}
				this.is_Loading = true
				var formData = new FormData();
				formData.append('csv', this.file);
				formData.append('zoneName', this.zoneName);
				formData.append('warehouseid', localStorage.getItem("selectedWarehouse"));
				formData.append('clientid', window.localStorage.getItem('selectedClient'));
				formData.append('username', this.username);
				let result = await axios.post(apiUrl.api_url + 'loadRacksForZone',
					formData, {
						headers: {
							'Authorization': 'Bearer ' + myStr,
							'Content-Type': 'multipart/form-data'
						}
					})
				if (result.data.errorCode == 0) {
					console.log("hello");
					this.getZoneList();
					document.getElementById('file').value = ''
					this.file = ''
					this.$alertify.success(result.data.count + " " + result.data.msg);

					this.addZonemodal = false
				} else {
					this.$alertify.error("Racks Not Mapped ")
				}
				this.is_Loading = false
			} catch (err) {
				console.log(err);
			}
		},
		async getRackListByWarehouse() {
			try {
				if (this.warehouse) {
					this.isLoading = true
					var userToken = window.localStorage.getItem('userToken')
					var myStr = userToken.replace(/"/g, '')
					let result = await axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getRackListByWarehouse',
						'data': {
							warehouseid: localStorage.getItem("selectedWarehouse")
						},
						'headers': {
							'Authorization': 'Bearer ' + myStr
						}
					})
					this.rackListData = result.data.data;
					this.isLoading = false
				}
			} catch (err) {
				console.log(err);
			}
		},
		searchFilter() {
			this.currentPage=1;
			console.log(this.warehouse);
			if (localStorage.getItem("selectedWarehouse")) {
				this.warehouseError = ''
				this.getRacksZonesList()
			} else {
				this.warehouseError =  this.$t('purchaseOrder.shipWarehouse');
			}
		},
		saveAddModal() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.submitFile()
					return false;
				} else {
					return false;
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
		resetFilter() {
			if (this.user_type != 'warehouse_user')
			{
			//  this.warehouse = ''
			}
			this.zone = ''
			this.rackName = ''
			this.warehouseError = ''
			this.totalrows = 0
			this.zoneListData = []
		},
		addNewZone() {
			document.getElementById('file').value = ''
			this.file = ''
			this.file = ''
			this.zoneName = ''
			this.addZonemodal = true
			if (this.systemLoginCheck && !this.warehouseLoginCheck) {
				this.warehouseModal = ''
				// this.warehouse = ''
			}
			this.zoneName = ''
			this.warehouseSelectedModal();
			this.$validator.reset();
		},
		async getWarehouseList() {
			try {
				this.isLoading = true
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				let result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': {},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				this.listWarehouseData = result.data.data;
				this.isLoading = false
			} catch (err) {
				console.log(err);
			}
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/rackZoneMaster/rackZoneMaster.component.js